import { Component, OnInit, inject } from '@angular/core';
import { SubscriptionService } from '../shared/core/state/subscription/subscription.service';
import { PageLoaderService } from '../shared/util/pageloader.service';
import { catchError, EMPTY, finalize } from 'rxjs';
import {
  Subscription,
  SubscriptionStatus,
} from '../shared/core/state/subscription/subscription.model';
import { ToastService } from '@black/ui';

@Component({
  selector: 'black-subscription',
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.css',
  standalone: false,
  host: {
    ngSkipHydration: 'true',
  },
})
export class SubscriptionComponent implements OnInit {
  private subscriptionService = inject(SubscriptionService);
  private pageLoaderService = inject(PageLoaderService);
  private toastService = inject(ToastService);


  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.pageLoaderService.open();
    this.fetchAllSubscriptions();
  }

  fetchAllSubscriptions() {
    this.subscriptionService
      .fetchAllSubscribtions()
      .pipe(finalize(() => this.pageLoaderService.close()))
      .subscribe((subscriptions) => {
        this.subscriptions = subscriptions;
      });
  }

  cancelSubscription(id: string) {
    this.subscriptionService.cancelSubscription(id).subscribe(() => {
      this.fetchAllSubscriptions();
    });
  }

  isCancelButtonDisabled(subscription: Subscription) {
    const disabledFor = [
      SubscriptionStatus.CANCELLED,
      SubscriptionStatus.COMPLETE,
    ];

    return (
      disabledFor.includes(subscription.status) ||
      subscription.isCancelRequested
    );
  }

  removeCancelRequest(id: string) {
    this.subscriptionService
      .removeCancelRequest(id)
      .pipe(
        catchError(() => {
          this.toastService.showToast(
            'Failed to remove cancel request',
            'error'
          );
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.fetchAllSubscriptions();
      });
  }
}
